import { useState, useEffect, useCallback } from 'react';
import { foodRun } from 'src/backend';

export default function useNotifyableDrivers(donationId, distanceMiles) {
  const [data, setData] = useState({ drivers: [], totalApplicable: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDrivers = useCallback(async () => {
    if (!donationId || distanceMiles == null) return;
    try {
      setLoading(true);
      setError(null);
      const res = await foodRun.getEligibleDrivers({
        id: donationId,
        radius: distanceMiles,
      });
      const sorted = [...(res.drivers || [])].sort(
        (a, b) => (a.distance ?? 0) - (b.distance ?? 0)
      );
      setData({
        drivers: sorted,
        totalApplicable: res.totalApplicable || sorted.length,
      });
    } catch (e) {
      setError(e);
      setData({ drivers: [], totalApplicable: 0 });
    } finally {
      setLoading(false);
    }
  }, [donationId, distanceMiles]);

  useEffect(() => {
    fetchDrivers();
  }, [fetchDrivers]);

  const clearError = useCallback(() => setError(null), []);

  return {
    drivers: data.drivers,
    totalApplicable: data.totalApplicable,
    isLoading: loading,
    error,
    refetch: fetchDrivers,
    clearError,
  };
}
